import listenForResponseOnVoice from './listenForResponseOnVoiceCall';

export default listenForResponseOnVoice;
